export interface DownloadPending {
    id: number;
    archivo: string;
    idMunicipio: number;
    estado: string;
    fechaPeticion: string;
    nombre: string;
    fechaBusqueda: string;
    progreso: number;
    TipoDescarga: string;
    FechaPeticionFormato: string;
    FechaBorrado: string;
    playbackUri: string;
    nombre_camara: string;
}

export interface DonwnloadPendingProcessed {
    FechaBorrado: string;
    FechaPeticionFormato: string;
    TipoDescarga: string;
    archivo: string;
    estado: string;
    fechaBusqueda: string;
    fechaBusquedaFin: string;
    fechaBusquedaInicio: string;
    fechaPeticion: string;
    fechamomento: string;
    fechanormal: string;
    fechautc: string;
    id: number;
    idMunicipio: number;
    nombre: string;
    progreso: number;
    playbackUri: string;
    nombre_camara?: string;
}

export interface DownloadPendingMultiple {
    idMunicipio: number;
    multipleDescarga: boolean;
    idMultipleDescarga: string;
    Usuario: string;
    nombreMunicipio: string;
    progresoPromedioMultipleDescarga: number;
    totalDescargasPorGrupo: number;
    fechaBusquedaInicio: string;
    fechaBusquedaFin: string;
    fechaPeticionInicioMinimo: string;
    estadoDescargaMasLejana: string;
    FechaBorrado: string;
    camaras: string;
}

export interface DownloadsSummary {
    message: string;
    totalFiles: number;
    errors: number;
    success: number;
    totalSize: string;
}

export interface FormattedTimeRestant {
    timeRestant: number;
    unit: 'segundos' | 'minutos' | 'horas' | 'dias';
}

export enum UpdateOptionsDownload {
    DELETE = 1,
    EXPIRED = 2,
    CANCEL = 3
}

export enum StateDownload {
    PENDING = 'PENDIENTE',
    GETTING = 'OBTENIENDO',
    CANCELING = 'CANCELANDO',
    EXPIRED = 'CADUCADO',
    AVAILABLE = 'DISPONIBLE',
    ERROR = 'ERROR'
}

export enum TimeRestant {
    'seconds' = 60,
    'minutes' = 3600,
    'hours' = 86400
}

export type optionsFilterDonwloads = 'TODOS' | 'PENDIENTE' | 'DISPONIBLE' | 'CADUCADO';
